import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";

export default function Layout() {
  return (
    <div className="flex bg-gray-50 dark:bg-gray-900 min-h-screen transition-colors">
      <Sidebar />
      <main className="flex-1 p-4 pt-16 md:pt-8 md:p-8 md:ml-64 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
